// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { DealerStateContext } from "@insite/client-framework/Store/Data/Dealers/DealersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { useContext } from "react";
import { css } from "styled-components";

export interface DealerImageStyles {
    wrapper?: InjectableCss;
    dealerImage?: LazyImageProps;
}

export const dealerImageStyles: DealerImageStyles = {
    dealerImage: {
        css: css`
            width: 100%;
            max-width: ${pxToRem(500)};
        `,
    },
};

const styles = dealerImageStyles;

const DealerImage = () => {
    const { value: dealer } = useContext(DealerStateContext);
    if (!dealer) {
        return null;
    }

    const imageSrc = dealer.properties.branchPicture ?? "userfiles/DefaultImage.jpg";

    return (
        <StyledWrapper {...styles.wrapper}>
            <LazyImage src={imageSrc} altText={dealer.name} {...styles.dealerImage} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: DealerImage,
    definition: {
        allowedContexts: ["DealerDetailsPage"],
        group: "Dealer Details",
    },
};

export default widgetModule;
